import {
    LICENSE_REGISTRATION_ENUM,
    SENT_MAIL_ENUM,
} from "@/constant/constants.ts";
import i18n from "@/i18n/i18n.ts";

const LICENSE_REGISTRATION_STATUS_OPTION = [
  { label: i18n.t("field.active"), value: LICENSE_REGISTRATION_ENUM.ACTIVE },
  {
    label: i18n.t("field.almostExpired"),
    value: LICENSE_REGISTRATION_ENUM.ALMOST_EXPIRED,
  },
  { label: i18n.t("field.expired"), value: LICENSE_REGISTRATION_ENUM.EXPIRED },
  {
    label: i18n.t("field.overdueRelease"),
    value: LICENSE_REGISTRATION_ENUM.OVERDUE_RELEASE,
  },
];

const LICENSE_REGISTRATION_SENT_STATUS_OPTION = [
  { label: i18n.t("field.notYet"), value: SENT_MAIL_ENUM.NOT_YET },
  { label: i18n.t("field.sent"), value: SENT_MAIL_ENUM.SENT },
];

export {
    LICENSE_REGISTRATION_SENT_STATUS_OPTION, LICENSE_REGISTRATION_STATUS_OPTION
};

